export default {
    list: {
        title: "Actividad",
        subtitle: "Ver actividad reciente",
        loading: "Cargando actividad...",
    },
    sender: {
        title: "Actividad",
        subtitle: "Actualizaciones y notificaciones para tu cuenta Remitente",
    },
    shipper: {
        title: "Actividad",
        subtitle: "Actualizaciones y notificaciones para tu cuenta Expedidor",
    },
    receiver: {
        title: "Actividad",
        subtitle: "Actualizaciones y notificaciones para tu cuenta Destinatario",
    },
    freightForwarder: {
        title: "Actividad",
        subtitle: "Actualizaciones operativas para tu cuenta Freight Forwarder",
    },
    actions: {
        markAllAsRead: "Marcar todo como leído",
        markingAsRead: "Marcando...",
    },
    tradeComms: {
        title: "Trade Communications",
        goToEmailSettings: "Ir a configuración de correo",
        sidebarTitle: "Trade Communications",
        collapseSidebar: "Contraer barra lateral",
        expandSidebar: "Expandir barra lateral",
        allInbox: "Todo el correo de entrada",
        allLimbo: "Todos los correos que requieren revisión",
        accounts: "Cuentas",
        accountAll: "Todo el correo de la cuenta",
        reviewNeeded: "Revisión necesaria",
        selectEmail: "Selecciona un correo para ver el contenido",
        noInbox: "No hay correos en la bandeja de entrada",
        noLimbo: "No hay correos en limbo",
        searchEmails: "Buscar correos...",
        yesterday: "Ayer",
    },
    systemLogs: {
        title: "Registro de actividad del sistema",
    },
    activityItem: {
        actionNeeded: "Acción requerida",
        reviewed: "Revisado",
        requiresReview: "Requiere revisión",
        account: "Cuenta:",
        from: "De:",
        received: "Recibido:",
        subject: "Asunto:",
        hideRecap: "Ocultar resumen",
        showRecap: "Mostrar resumen",
        file: "Archivo:",
        type: "Tipo:",
        category: "Categoría:",
        uploadedBy: "Subido por:",
        classifiedBy: "Clasificado por:",
        source: "Fuente:",
        sourceEmail: "Desde email",
        sourceManual: "Carga manual",
        reportedBy: "Reportado por:",
        severity: "Severidad:",
        name: "Nombre:",
        email: "Email:",
        company: "Empresa:",
        role: "Rol:",
        modifiedBy: "Modificado por:",
        modifiedFields: "Campos modificados:",
        delayHours: "{{hours}}h de retraso",
        originalEta: "ETA original:",
        currentEta: "ETA actual:",
        vessel: "Buque:",
        passed: "{{count}} aprobados",
        failed: "{{count}} fallidos",
        missing: "{{count}} faltantes",
        skipped: "{{count}} omitidos",
        hideDetails: "Ocultar detalles",
        issuesDetected: "{{count}} problemas detectados",
        moreOthers: "+ {{count}} otros",
        risk: "Riesgo:",
        activeIssues: "Issues activas:",
        issuesAutoClosed: "{{count}} issues auto-cerradas",
        container: "Contenedor:",
        moreAttachments: "+ {{count}} adjuntos",
        containerDeleted: "Contenedor eliminado",
        containerDeletedTooltip: "Este contenedor ha sido eliminado",
        synced: "Sincronizado",
        fields: {
            actualDepartureDate: "Fecha de salida real",
            riskScore: "Nivel de riesgo",
            destinationPortId: "Puerto de destino",
            totalValueUsd: "Valor (USD)",
            physicalStatus: "Estado físico",
            status: "Estado",
            containerNumber: "Número de contenedor",
            bookingNumber: "Número de reserva",
            estimatedArrivalDate: "ETA",
            estimatedDepartureDate: "ETD",
        },
    },
    emailActions: {
        markNotInContext: {
            label: "No en Contexto",
            confirmTitle: "Eliminar Correo del Contexto",
            confirmMessage:
                "¿Estás seguro de que quieres marcar este correo como no relevante? El correo se eliminará del contexto logístico y ya no se procesará.",
            cancel: "Cancelar",
            confirm: "Eliminar del Contexto",
            marking: "Eliminando...",
            success: "Correo marcado como no en contexto",
            error: "Error al marcar el correo",
        },
        closeDetail: "Cerrar detalle",
        associateContainer: {
            label: "Asociar a Contenedor",
            title: "Asociar Correo a Contenedor",
            description: "Selecciona el contenedor al que quieres asociar este correo. El sistema procesará automáticamente el contenido.",
            inputLabel: "Número de Contenedor",
            inputPlaceholder: "Buscar y seleccionar un contenedor...",
            loadingContainers: "Cargando contenedores...",
            cancel: "Cancelar",
            confirm: "Asociar",
            associating: "Asociando...",
            success: "Correo asociado al contenedor con éxito",
            error: "Error al asociar el correo",
        },
    },
    activityFeed: {
        categories: {
            document: "Documentos",
            tracking: "Seguimiento",
            contact: "Agenda",
            agent: "Sistema",
            other: "Otro",
        },
        sectionSettings: "Configuración de secciones",
        sectionOrderVisibility: "Orden y visibilidad de secciones",
        loadMoreActivities: "Cargar más actividades",
        nextSlide: "Siguiente diapositiva",
        noActivities: "No se encontraron actividades con los filtros seleccionados.",
        noMoreToLoad: "No hay más para cargar",
        expandSection: "Expandir {{label}}",
        collapseSection: "Contraer {{label}}",
        moveUp: "Mover {{label}} arriba",
        moveDown: "Mover {{label}} abajo",
        show: "Mostrar",
        hide: "Ocultar",
    },
};
